import { Dispatch, SetStateAction, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
    Modal,
    Button,
    MenuItem,
    TextField,
    Chip,
    Box,
} from "@mui/material";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

const TAG_OPTIONS = [
    "selling fast",
    "new arrival",
    "best seller",
    "limited stock",
];

export default function EditTags({
    open,
    onClose,
    setOpen,
}: ModalProps) {
    const [tagType, setTagType] = useState("PRODUCTS");
    const [tags, setTags] = useState<string[]>(["selling fast"]);

    return (
        <Modal className="modal rejectReason_modal" open={open} onClose={onClose}>
            <div className="modal-dialog">
                <div className="modal-body">

                    {/* Header */}
                    <div className="modal_title">
                        <h2>Edit Tags</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    {/* Form */}
                    <form className="form">
                        <div className="gap_p">

                            {/* Tag Type */}
                            <div className="control_group">
                                <label htmlFor="tag-type">
                                    Tag Type <span className="required">*</span>
                                </label>

                                <TextField
                                    select
                                    fullWidth
                                    value={tagType}
                                    onChange={(e) => setTagType(e.target.value)}
                                    inputProps={{ id: "tag-type" }}
                                >
                                    <MenuItem value="PRODUCTS">PRODUCTS</MenuItem>
                                    <MenuItem value="STORES">STORES</MenuItem>
                                    <MenuItem value="CATEGORIES">CATEGORIES</MenuItem>
                                </TextField>
                            </div>
                            <div className="control_group">
                                <label htmlFor="tag-collection">
                                    Collection <span className="required">*</span>
                                </label>

                                <TextField
                                    select
                                    fullWidth
                                    value={tagType}
                                    onChange={(e) => setTagType(e.target.value)}
                                    inputProps={{ id: "tag-collection" }}
                                >
                                    <MenuItem value="PRODUCTS">Collection 1</MenuItem>
                                    <MenuItem value="STORES">Collection 2</MenuItem>
                                    <MenuItem value="CATEGORIES">Collection 3</MenuItem>
                                </TextField>
                            </div>
                        </div>

                        {/* Footer */}
                        <div className="footer_btn_flex">
                            <Button className="btn" onClick={() => setOpen(false)}>
                                Cancel
                            </Button>

                            <Button className="btn btn_primary">
                                Save Tags
                            </Button>
                        </div>
                    </form>

                </div>
            </div>
        </Modal>
    );
}
